import axios from "axios";

export function resolveApiBase(backendUrl) {
  const normalized = (backendUrl || "").trim().replace(/\/+$/, "");
  return normalized ? `${normalized}/api` : "/api";
}

export const API = resolveApiBase(process.env.REACT_APP_BACKEND_URL);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const publicApi = axios.create({
  baseURL: "/api",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lf_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
